<template>
  <div
    v-resize="onResize"
    elevation="0"
    :style="{
      backgroundColor: $vuetify.theme.dark
        ? fixedHeight
          ? '#1E1E1E'
          : 'transparent'
        : fixedHeight
        ? 'white'
        : 'transparent',
    }"
  >
    <v-row
      justify-lg="end"
      justify-sm="end"
      justify="end"
      class="mr-0 pl-lg-0 pb-3 pt-3"
      v-if="defaultCart"
      :class="{ 'mr-3': fixedHeight }"
    >
      <v-spacer></v-spacer>
      <v-btn
        elevation="0"
        min-width="36"
        min-height="36"
        :disabled="savingInProgress"
        @click="$store.dispatch('cart/removeActiveCart')"
        color="red lighten-2"
        class="mb-0 ml-3 px-0 my-2 white--text"
        :title="$t('componentMultiCart.remove_active_cart')"
      >
        <v-icon small>$trash</v-icon>
      </v-btn>
      <v-btn
        elevation="0"
        min-width="36"
        min-height="36"
        :disabled="!defaultCart.items.length || savingInProgress"
        class="mb-0 white--text ml-3 px-0 my-2"
        @click="
          createCalculation(defaultCart);
          cartVisible = false;
        "
        color="orange lighten-3"
        :title="$t('common.create_calculation')"
      >
        <v-icon small>$calculator</v-icon>
      </v-btn>
      <v-btn
        elevation="0"
        min-width="36"
        min-height="36"
        color="primary"
        :disabled="savingInProgress"
        class="mb-0 ml-3 px-0 my-2"
        @click="
          dialogRename = true;
          newCartName = defaultCart.name;
        "
        :title="$t('common.rename')"
      >
        <v-icon small>$pencil</v-icon>
      </v-btn>
      <v-btn
        min-width="36"
        min-height="36"
        :disabled="!defaultCart.items.length || savingInProgress"
        :loading="savingInProgress"
        class="mb-0 white--text ml-3 px-0 green-shadow my-2"
        @click="
          checkoutOrder(defaultCart);
          cartVisible = false;
        "
        id="checkoutOrderBtn"
        color="success"
        :title="
          !defaultCart.order_id
            ? $t('common.checkout_order')
            : $t('componentMultiCart.add_to_order')
        "
      >
        <v-icon v-if="!defaultCart.order_id" small>$checkout</v-icon>
        <v-icon v-else small>mdi-shape-plus</v-icon>
      </v-btn>
<!--      <span-->
<!--        :title="-->
<!--          defaultCart.car && defaultCart.car.vin-->
<!--            ? ''-->
<!--            : $t('componentMultiCart.car_vin_not_found')-->
<!--        "-->
<!--      >-->
<!--        <v-btn-->
<!--          min-height="36"-->
<!--          :disabled="-->
<!--            !defaultCart.items.length ||-->
<!--            !(defaultCart.car && defaultCart.car.vin) ||-->
<!--            savingInProgress-->
<!--          "-->
<!--          class="mb-0 white&#45;&#45;text ml-3 green-shadow my-2"-->
<!--          @click="defaultCartCheck()"-->
<!--          color="success"-->
<!--          :title="$t('componentMultiCart.check_cart')"-->
<!--        >-->
<!--          <v-icon small left>$check</v-icon>-->
<!--          {{ $t("componentMultiCart.check_cart") }}-->
<!--        </v-btn>-->
<!--      </span>-->
    </v-row>
    <v-card class="elevation-0 overflow-auto" :disabled="savingInProgress">
      <v-container fluid class="py-0 ma-0">
        <v-row>
          <div
            cols="2"
            class="flex-grow-0 flex-shrink-0 align-self-center pa-0 ma-0"
          >
            <v-btn
              color="success"
              class="ml-5 green-shadow"
              x-small
              fab
              max-width="26"
              max-height="26"
              @click="$store.dispatch('cart/createCart', {})"
            >
              <v-icon x-small>$plus</v-icon>
            </v-btn>
          </div>
          <v-col cols="10" class="flex-grow-1 flex-shrink-0 py-0 px-1">
            <v-tabs center-active show-arrows v-model="cartTab">
              <v-tab v-for="cart in carts" :key="cart.id">
                {{ cart.name }}
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-tabs height="1px" v-model="cartTab">
          <v-tabs-items v-model="cartTab">
            <v-tab-item v-for="cart in carts" :key="cart.id">
              <v-card
                flat
                class="pt-0"
                :class="{ fixedHeight: fixedHeight, 'pt-1': fixedHeight }"
              >
                <v-row>
                  <v-col class="py-0 my-0">
                    <template v-if="cart.customer || cart.order">
                      <v-row>
                        <v-col class="py-0 my-0" xs="3">
                          <span class="text-caption d-block">{{
                            !!cart.order
                              ? $t("common.order")
                              : $t("common.customer")
                          }}</span>
                          <span
                            v-if="cart.customer && !cart.order"
                            class="text-no-wrap"
                          >
                            <span
                              class="dashed"
                              @click="
                                customerFormDialog.isVisible = true;
                                customerFormDialog.customerId =
                                  cart.customer.id;
                                customerFormTabsId = 0;
                              "
                            >
                              {{ cart.customer.full_name }}
                            </span>
                            <v-btn
                              max-height="20"
                              max-width="20"
                              icon
                              @click="
                                cart.customer = null;
                                cart.car = null;
                                $store.dispatch('cart/updateCart', cart);
                              "
                              class="mr-2"
                            >
                              <v-icon x-small>fa-times</v-icon>
                            </v-btn>
                          </span>
                          <span v-if="cart.order" class="text-no-wrap">
                            {{ orderCaption(cart.order) }}
                            <v-btn
                              max-height="20"
                              max-width="20"
                              icon
                              @click="
                                cart.order = null;
                                cart.customer = null;
                                cart.car = null;
                                $store.dispatch('cart/updateCart', cart);
                              "
                              class="mr-2"
                            >
                              <v-icon x-small>fa-times</v-icon>
                            </v-btn>
                          </span>
                        </v-col>
                        <v-col class="py-0 my-0" xs="3">
                          <span class="text-caption d-block">{{
                            $t("common.car")
                          }}</span>
                          <span
                            class="dashed"
                            @click="showGarageForSelectCar(cart)"
                          >
                            {{
                              cart.car
                                ? cart.car.name +
                                  (cart.car.car_number
                                    ? " [" +
                                      cart.car.car_number.toUpperCase() +
                                      "] "
                                    : "")
                                : ""
                            }}
                            <span v-if="!cart.car">{{
                              $t("common.not_selected")
                            }}</span>
                          </span>
                        </v-col>
                        <v-col class="py-0 my-0 text-right" xs="3">
                          <span v-if="cart.car">
                            <v-btn
                              elevation="0"
                              color="light-grey"
                              min-width="48"
                              min-height="48"
                              :disabled="!cart.car.maintenance_part_available"
                              @click="
                                $store.dispatch('garage/maintenanceParts', {
                                  brand: cart.car.brand,
                                  link: cart.car.levam_link,
                                  car: cart.car,
                                });
                                maintenancePartsForm = true;
                              "
                              :title="$t('common.maintenance_parts')"
                            >
                              <v-icon small>$oils</v-icon>
                            </v-btn>

                            <v-btn
                              class="ml-2"
                              elevation="0"
                              min-width="48"
                              min-height="48"
                              :disabled="
                                !cart.car.levam_link ||
                                cart.car.levam_link == -1
                                || cart.car.levam_link.toString().length < 10
                              "
                              @click="toOEMWidget(cart.car)"
                              title="OEM"
                            >
                              <v-icon small>$oem</v-icon>
                            </v-btn>
                          </span>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-if="!cart.customer && !cart.order">
                      <v-row>
                        <v-col cols="5" class="py-0">
                          <order-search-input
                            @select="
                              (order) => {
                                cart.order = order;
                                cart.order_id = cart.order.id;
                                cart.customer = cart.order.customer;
                                cart.car = order.car;
                                $store.dispatch('cart/updateCart', cart);
                              }
                            "
                            :label="$t('common.order')"
                            :placeholder="$t('common.start_typing_to_search')"
                          ></order-search-input>
                        </v-col>
                        <v-col cols="2" class="py-0 text-center">
                          {{ $t("componentMultiCart.or") }}
                        </v-col>
                        <v-col cols="5" class="py-0">
                          <customerFindForm
                            :dense="true"
                            @select="
                              (data) => {
                                cart.customer = data;
                                $store.dispatch('cart/updateCart', cart);
                              }
                            "
                            :visible="true"
                          ></customerFindForm>

                          <v-dialog
                            v-model="customerCreateForm"
                            scrollable
                            max-width="800px"
                          >
                            <div class="customerCreateForm">
                              <customerForm
                                @removed="customerCreateForm = false"
                                :is-visible="customerCreateForm"
                                class="ma-3"
                                @store="
                                  (data) => {
                                    $store.dispatch('customers/get');
                                    cart.customer = data.new;
                                    customerCreateForm = false;
                                  }
                                "
                              >
                              </customerForm>
                            </div>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <i class="d-block text-center py-3" v-if="cartType === null">{{
                  $t("componentMultiCart.cart_is_empty")
                }}</i>
                <!-- таблица с деталями-->
                <multi-cart-parts-table
                  @close="emitClose"
                  :loading="cartIsLoading"
                  :disabled="cartIsLoading"
                  v-if="
                    cartType === 'parts' &&
                    cart.id === activeCartId &&
                    isVisible
                  "
                  :data="cart.items.filter((item) => item.type == 'part')"
                  :id="fixedHeight ? 'fixedTableCart' : 'tableCart'"
                  :height="fixedHeight ? undefined : tableHeight"
                  :show-footer="true"
                  :is-visible="isVisible"
                />

                <!-- таблица с работами-->
                <v-data-table
                  :loading="cartIsLoading"
                  v-if="
                    cartType === 'repairtimes' &&
                    cart.id === activeCartId &&
                    isVisible
                  "
                  :options="{
                    itemsPerPage: 1000,
                  }"
                  :headers="[
                    {
                      text: $t('common.title'),
                      value: 'name',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.repairtime'),
                      value: 'time',
                      align: 'right',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.amount'),
                      value: 'amount',
                      align: 'center',
                      width: '200px',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.price'),
                      value: 'price',
                      align: 'right',
                      class: 'text-no-wrap',
                    },
                    { text: $t('common.total_sum'), class: 'text-no-wrap' },
                  ]"
                  :items="
                    cart.items.filter((item) => item.type == 'repairtime')
                  "
                  hide-default-footer
                  class="elevation-1 mb-3"
                  :id="fixedHeight ? 'fixedTableCart' : 'tableCart'"
                  :height="tableHeight"
                >
                  <template v-slot:item="items">
                    <tr>
                      <td class="text-left">{{ items.item.name }}</td>
                      <td class="text-right">{{ items.item.time }}</td>
                      <td class="text-center" style="width: 200px">
                        <v-container>
                          <v-row class="">
                            <v-col cols="12" sm="6" md="4">
                              <v-btn
                                depressed
                                fab
                                x-small
                                @click="
                                  $store.dispatch(
                                    'cart/removeFromCart',
                                    items.item
                                  )
                                "
                              >
                                -
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <edit-value-menu
                                  :item="items.item"
                                  :field-name="'amount'"
                                  @update="(item)=>{items.item=item;cartItemUpdate(items.item)}"
                                  :disabled=" ! (items.item.nomenclature &&
                                    items.item.nomenclature.unit_of_measurement &&
                                    items.item.nomenclature.unit_of_measurement.is_divisible &&
                                    items.item.nomenclature.unit_of_measurement.is_divisible === 1)  || !isEnabledStorageV2"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-btn
                                depressed
                                fab
                                x-small
                                @click="
                                  $store.dispatch('cart/addToCart', items.item)
                                "
                                >+
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </td>
                      <td class="text-right">
                        <v-menu
                          v-model="priceMenu[items.item.id]"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          offset-x
                        >
                          <template v-slot:activator="{ on }">
                            <a v-on="on" @click="priceTmp = items.item.price">
                              {{ items.item.price }}
                            </a>
                          </template>

                          <v-card>
                            <v-list>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-text-field
                                    :placeholder="$t('common.price')"
                                    v-model="priceTmp"
                                    required
                                    type="numeric"
                                    :rules="[
                                      (v) =>
                                        !!v ||
                                        $t(
                                          'form.validationErrors.field_is_required'
                                        ),
                                    ]"
                                  ></v-text-field>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>

                              <v-btn
                                text
                                @click="priceMenu[items.item.id] = false"
                                >{{ $t("common.cancel") }}
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="
                                  priceMenu[items.item.id] = false;
                                  items.item.price = priceTmp;
                                  cartItemUpdate(items.item);
                                "
                              >
                                {{ $t("common.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </td>
                      <td class="text-right text-no-wrap">
                        {{
                          formatCurrency(parseFloat(
                            items.item.price * items.item.amount
                          ).toFixed(2))
                        }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append="items">
                    <tr class="text-xs-left">
                      <td colspan="2" class="text-sm-right"></td>
                      <td class="text-center">
                        <strong>{{
                          Object.values(items.items).reduce(
                            (sum, item) =>
                              item.amount + sum,
                            0
                          ).toFixed(2)
                        }}</strong>
                      </td>
                      <td class="text-sm-right"></td>
                      <td class="text-sm-right">
                        <strong class="text-no-wrap">{{
                            formatCurrency(Object.values(items.items).reduce(
                            (sum, item) =>
                              (
                                parseFloat(item.price * item.amount) +
                                parseFloat(sum)
                              ).toFixed(2),
                            0
                          ))
                        }} </strong>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("common.no_data_available") }}
                  </template>
                  <template v-slot:no-results>
                    {{ $t("common.no_data_available") }}
                  </template>
                </v-data-table>
                <!-- таблица с работами и деталями-->
                <v-data-table
                  v-if="
                    cartType == 'summary' &&
                    cart.id === activeCartId &&
                    isVisible
                  "
                  :headers="[
                    { text: '', value: 'data-table-expand' },
                    {
                      text: $t('common.title'),
                      value: 'name',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.repairtime'),
                      value: 'time',
                      align: 'right',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.amount'),
                      value: 'amount',
                      align: 'center',
                      width: '200px',
                      class: 'text-no-wrap',
                    },
                    {
                      text: $t('common.price'),
                      value: 'price',
                      align: 'right',
                      class: 'text-no-wrap',
                    },
                    { text: $t('common.total_sum'), class: 'text-no-wrap' },
                  ]"
                  :items="
                    cart.items.filter((item) => item.type == 'repairtime')
                  "
                  :expanded="expanded"
                  show-expand
                  class="elevation-0 mb-3 rounded-0"
                  hide-default-footer
                  :height="tableHeight"
                  :options="{
                    itemsPerPage: 1000,
                  }"
                >
                  <template v-slot:item="items">
                    <tr class="no-zebra">
                      <td class="pa-0 pl-1">
                        <v-btn
                          :color="$vuetify.theme.dark ? 'light' : 'white'"
                          depressed
                          fab
                          x-small
                          @click="toggleExpanded(items.item)"
                          v-if="
                            cart.items.filter(
                              (el) =>
                                el.type == 'part' &&
                                el.repairtime_id_in_cart == items.item.id
                            ).length
                          "
                        >
                          <v-icon v-if="expanded.includes(items.item)"
                            >mdi-chevron-up
                          </v-icon>
                          <v-icon v-else>mdi-chevron-down</v-icon>
                        </v-btn>
                      </td>
                      <td class="text-left">
                        <v-icon small color="red" left>$tools</v-icon>
                        {{ items.item.name }}<br />
                        <template
                          v-if="
                            cart.items.filter(
                              (el) =>
                                el.type == 'part' &&
                                el.repairtime_id_in_cart == items.item.id
                            ).length
                          "
                        >
                          <!-- Деталей: -->
                          <span class="mr-5 grey--text text--lighten-1">
                            {{ $t("componentMultiCart.parts_num") }}:
                            {{
                              Object.values(
                                cart.items.filter(
                                  (el) =>
                                    el.type == "part" &&
                                    el.repairtime_id_in_cart == items.item.id
                                )
                              ).reduce(
                                (sum, it) =>
                                  it.amount + sum,
                                0
                              ).toFixed(2)
                            }}
                          </span>
                          <!-- на сумму:  -->
                          <span class="ml-5 grey--text text--lighten-1 text-no-wrap">
                            {{ $t("componentMultiCart.on_sum") }}:
                            {{
                              formatCurrency(Object.values(
                                cart.items.filter(
                                  (el) =>
                                    el.type == "part" &&
                                    el.repairtime_id_in_cart == items.item.id
                                )
                              ).reduce(
                                (sum, item) =>
                                  (
                                    parseFloat(item.price * item.amount) +
                                    parseFloat(sum)
                                  ).toFixed(2),
                                0
                              ))
                            }}
                          </span>
                        </template>
                      </td>
                      <td class="text-right">{{ items.item.time }}</td>
                      <td class="text-center">
                        <v-container
                          class="justify-center d-flex"
                          style="width: 100px"
                        >
                          <v-row class="mx-0" justify="center" no-gutters>
                            <v-col class="pa-0">
                              <v-btn
                                max-width="17"
                                max-height="17"
                                outlined
                                color="pink darken-1"
                                fab
                                x-small
                                @click="
                                  $store.dispatch(
                                    'cart/removeFromCart',
                                    items.item
                                  )
                                "
                                >-
                              </v-btn>
                            </v-col>
                            <v-col class="pa-0">
                              <edit-value-menu
                                  :item="items.item"
                                  :field-name="'amount'"
                                  @update="(item)=>{items.item=item;cartItemUpdate(items.item)}"
                                  :disabled=" ! (items.item.nomenclature &&
                                    items.item.nomenclature.unit_of_measurement &&
                                    items.item.nomenclature.unit_of_measurement.is_divisible &&
                                    items.item.nomenclature.unit_of_measurement.is_divisible === 1)  || !isEnabledStorageV2"
                              />
                            </v-col>
                            <v-col class="pa-0">
                              <v-btn
                                max-width="17"
                                max-height="17"
                                outlined
                                color="success"
                                depressed
                                fab
                                x-small
                                @click="
                                  $store.dispatch('cart/addToCart', items.item)
                                "
                                >+
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </td>
                      <td class="text-right">
                        <v-menu
                          v-model="priceMenu[items.item.id]"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          offset-x
                        >
                          <template v-slot:activator="{ on }">
                            <a v-on="on" @click="priceTmp = items.item.price" class="text-no-wrap">
                              {{ formatCurrency(items.item.price) }}
                            </a>
                          </template>

                          <v-card>
                            <v-list>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-text-field
                                    :placeholder="$t('common.price')"
                                    v-model="priceTmp"
                                    required
                                    type="numeric"
                                    :rules="[
                                      (v) =>
                                        !!v ||
                                        $t(
                                          'form.validationErrors.field_is_required'
                                        ),
                                    ]"
                                  ></v-text-field>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>

                              <v-btn
                                text
                                @click="priceMenu[items.item.id] = false"
                                >{{ $t("common.cancel") }}
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="
                                  priceMenu[items.item.id] = false;
                                  items.item.price = priceTmp;
                                  cartItemUpdate(items.item);
                                "
                              >
                                {{ $t("common.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </td>
                      <td class="text-right text-no-wrap">
                        {{
                          formatCurrency(parseFloat(
                            items.item.price * items.item.amount
                          ).toFixed(2))
                        }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="px-0">
                      <multi-cart-parts-table
                        @close="emitClose"
                        :data="
                          cart.items.filter(
                            (el) =>
                              el.type == 'part' &&
                              el.repairtime_id_in_cart == item.id
                          )
                        "
                        :id="fixedHeight ? 'fixedTableCart' : 'tableCart'"
                        height="auto"
                      />
                    </td>
                  </template>
                  <template v-slot:body.append="items">
                    <tr class="no-zebra">
                      <td class="pa-0 pl-1">
                        <v-btn
                          v-if="
                            cart.items.filter(
                              (el) =>
                                el.type == 'part' &&
                                el.repairtime_id_in_cart == null
                            ).length > 0
                          "
                          :color="$vuetify.theme.dark ? 'light' : 'white'"
                          depressed
                          fab
                          x-small
                          @click="showUnattachedParts = !showUnattachedParts"
                        >
                          <v-icon v-if="showUnattachedParts"
                            >mdi-chevron-up
                          </v-icon>
                          <v-icon v-else>mdi-chevron-down</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <template
                          v-if="
                            cart.items.filter(
                              (el) =>
                                el.type == 'part' &&
                                el.repairtime_id_in_cart == null
                            ).length
                          "
                        >
                          <i>{{
                            $t("componentMultiCart.parts_without_repairtimes")
                          }}</i>
                          <br />
                          <!--  Деталей: -->
                          <span class="mr-5 grey--text text--lighten-1">
                            {{ $t("componentMultiCart.parts_num") }}:
                            {{
                              Object.values(
                                cart.items.filter(
                                  (el) =>
                                    el.type == "part" &&
                                    el.repairtime_id_in_cart == null
                                )
                              ).reduce(
                                (sum, it) =>
                                  it.amount + sum,
                                0
                              ).toFixed(2)
                            }}
                          </span>
                          <!--  На сумму: -->
                          <span class="ml-5 grey--text text--lighten-1 text-no-wrap">
                            {{ $t("componentMultiCart.on_sum") }}:
                            {{
                              formatCurrency(Object.values(
                                cart.items.filter(
                                  (el) =>
                                    el.type == "part" &&
                                    el.repairtime_id_in_cart == null
                                )
                              ).reduce(
                                (sum, it) =>
                                  (
                                    parseFloat(it.price * it.amount) +
                                    parseFloat(sum)
                                  ).toFixed(2),
                                0
                              ))
                            }}
                          </span>
                        </template>
                        <template v-else>
                          <i>{{
                            $t(
                              "componentMultiCart.none_parts_without_repairtimes"
                            )
                          }}</i>
                        </template>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr
                      v-if="
                        showUnattachedParts &&
                        cart.items.filter(
                          (el) =>
                            el.type == 'part' &&
                            el.repairtime_id_in_cart == null
                        ).length
                      "
                    >
                      <td colspan="6" class="pa-0 ma-0">
                        <multi-cart-parts-table
                          @close="emitClose"
                          :data="
                            cart.items.filter(
                              (el) =>
                                el.type == 'part' &&
                                el.repairtime_id_in_cart == null
                            )
                          "
                          :id="fixedHeight ? 'fixedTableCart' : 'tableCart'"
                          :height="tableHeight"
                        />
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("common.no_data_available") }}
                  </template>
                  <template v-slot:no-results>
                    {{ $t("common.no_data_available") }}
                  </template>
                </v-data-table>
                <p class="ma-0 text-right">
                  {{ $t("common.total_sum") }}<br />
                  <strong class="text--red text-h6 font-weight-bold text-no-wrap">{{
                      formatCurrency(cart.total_sum)
                  }}</strong>
                </p>
                <span
                  id="isCartSumMoreThanZeroPlaceholder"
                  v-if="
                    cart.total_sum > 0 && cart.id === activeCartId && isVisible
                  "
                ></span>
                <span
                  id="hasCartRepairtimesPlaceholder"
                  v-if="
                    cart &&
                    cart.items &&
                    cart.items.length > 0 &&
                    cart.items.filter((it) => it.type === 'repairtime').length >
                      0
                  "
                ></span>
              </v-card>
              <v-dialog
                persistent
                v-model="dialogRename"
                scrollable
                max-width="650px"
              >
                <v-card>
                  <v-card-title>{{ $t("common.rename") }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      outlined
                      :value="newCartName"
                      v-model="newCartName"
                    >
                    </v-text-field>
                    <v-divider></v-divider>
                    <v-row justify="start">
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="cartIsLoading"
                        class="mr-2 mt-4 white--text"
                        color="red"
                        elevation="0"
                        @click="
                          dialogRename = false;
                          newCartName = cart.name;
                        "
                      >
                        {{ $t("common.cancel") }}
                      </v-btn>
                      <v-btn
                        :loading="cartIsLoading"
                        class="mr-2 mt-4 white--text"
                        color="primary"
                        elevation="0"
                        @click="renameCart"
                      >
                        {{ $t("common.save") }}
                      </v-btn>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-dialog
        v-model="customerFormDialog.isVisible"
        scrollable
        max-width="890"
      >
        <customerForm
          @removed="customerFormDialog.isVisible = false"
          :is-visible="customerFormDialog.isVisible"
          v-if="customerFormDialog.isVisible"
          @update="
            (data) => {
              customerFormDialog.isVisible = false;
              customerFormDialog.carId = -1;
              customerFormDialog.customerId = null;
              defaultCart.customer = data;
            }
          "
          :car-id="customerFormDialog.carId"
          @chooseCar="
            (car) => {
              defaultCart.car = car;
              $store.dispatch('cart/updateCart', defaultCart);
              customerFormDialog.customerId = null;
              customerFormDialog.carId = -1;
              customerFormDialog.isVisible = false;
            }
          "
          :customer-id="customerFormDialog.customerId"
        ></customerForm>
      </v-dialog>
      <v-dialog v-model="maintenancePartsForm" scrollable max-width="90%">
        <maintenanceParts></maintenanceParts>
      </v-dialog>
      <order-window
          :is-visible="orderWindow.isVisible"
          :order-id="orderWindow.orderId"
          @hide="orderWindow.orderId=null; orderWindow.isVisible=false;"
      />
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import MultiCartPartsTable from "./MultiCartPartsTable";
import CustomerForm from "../customer/CustomerForm";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import CommonMixin from "@/mixins/common";
import OrderSearchInput from "@/components/common/OrderSearchInput";
import CustomerFindForm from "@/components/customer/CustomerFindForm";
import OrderWindow from "@/components/order/OrderWindow.vue";
import EditValueMenu from "@/components/common/EditValueMenu.vue";

export default {
  name: "MultiCart",
  components: {
    EditValueMenu,
    OrderWindow,
    CustomerFindForm,
    OrderSearchInput,
    CustomerForm,
    MultiCartPartsTable,
    MaintenanceParts,
  },
  mixins: [CommonMixin],
  props: {
    isVisible: null,
    fixedHeight: {
      type: Boolean,
      default: false,
    },
    /*
      При изменении вызывается this.onResize();
     */
    watcherForResize: null,
  },
  data: () => ({
    customerFormDialog: {
      customerId: null,
      isVisible: false,
      carId: -1,
    },
    maintenancePartsForm: false,
    isVisibleCustomerFindForm: false,
    customerCreateForm: false,
    showUnattachedParts: false,
    dialogRename: false,
    newCartName: "",
    tableHeight: null,
    expanded: [],
    priceMenu: {},
    priceTmp: null,
    amountMenu:{},
    amountTmp:null,
    orderWindow: {
      orderId: null,
      isVisible: false
    }
  }),
  mounted() {
    this.$nextTick(function () {
      this.onResize();
    });
    this.$store.dispatch("customers/get");
  },
  watch: {
    watcherForResize() {
      this.$nextTick(function () {
        this.onResize();
      });
    },
    expanded(from, to) {
      this.onResize();
    },
    defaultCartId() {
      this.expanded = [];
    },
    carts() {
      this.$nextTick(function () {
        this.onResize();
      });
    },
    cartIsLoading(){
      if(this.cartIsLoading===false) {
        this.defaultCartCheck();
      }
    }
  },
  computed: {
    ...mapFields("orders", ["newOrder", "savingInProgress"]),
    ...mapFields("garage", ["tmpCarId"]),
    ...mapFields("customers", ["customer", "customerFormTabsId", "customers"]),
    ...mapFields("auth", ["authenticated"]),
    ...mapFields("cart", [
      "defaultCartCounter",
      "defaultCart",
      "carts",
      "defaultCartId",
      "cartIsLoading",
      "cartType",
    ]),
    defaultCart: {
      get() {
        return this.$store.getters["cart/defaultCart"];
      },
      set(val) {
        //return this.$store.getters['cart/defaultCart'];
        for (let i in this.carts) {
          if (parseInt(this.carts[i].id) === parseInt(this.defaultCartId)) {
            this.carts[i] = val;
          }
        }
      },
    },
    cartType() {
      let partsNum = this.defaultCart.items.filter(
        (it) => it.type === "part"
      ).length; //число деталей в корзине
      let repairtimesNum = this.defaultCart.items.filter(
        (it) => it.type === "repairtime"
      ).length; //число работ в корзине

      if (partsNum > 0 && repairtimesNum > 0) return "summary";
      if (partsNum > 0 && repairtimesNum < 1) return "parts";
      if (partsNum < 1 && repairtimesNum > 0) return "repairtimes";
      return null;
    },
    cartTab: {
      get() {
        for (let i in this.carts) {
          if (this.carts[i].id == this.defaultCartId) {
            return parseInt(i);
          }
        }
      },
      set(num) {
        for (let i in this.carts) {
          if (parseInt(i) === parseInt(num)) {
            this.$store.dispatch("cart/setDefaultCart", this.carts[i].id);
          }
        }
      },
    },
    activeCartName() {
      for (let i in this.carts) {
        if (parseInt(i) === parseInt(this.cartTab)) {
          this.newCartName = this.carts[i].name;
          return this.carts[i].name;
        }
      }
    },
    activeCartId() {
      for (let i in this.carts) {
        if (parseInt(i) === parseInt(this.cartTab)) {
          this.newCartName = this.carts[i].id;
          return this.carts[i].id;
        }
      }
    },
  },
  methods: {
    emitClose() {
      //эмитируем событие для закрытия окна корзины когда она в окне
      this.$emit("close");
    },
    orderCaption(order) {
      let date = this.$moment(order.created_at).format("DD.MM.YYYY HH:mm");
      return `#${order.human_number} (${this.formatCurrency(order.total_sum)})
      ${order.customer.last_name} ${order.customer.first_name} ${
        order.customer.patronymic ? order.customer.patronymic : ""
      }
      [${date}]`;
    },
    cartItemUpdate(item) {
      this.$store
        .dispatch("cart/cartItemUpdate", {
          id: this.defaultCart.id,
          item: item,
        })
        .then((data) => {});
    },
    defaultCartCheckResult() {
      this.$store
        .dispatch("cart/cartCheckResult", { id: this.defaultCart.id })
        .then((data) => {
          if (
            data &&
            data.result &&
            data.result.error !== "" &&
            data.result.error !== undefined
          ) {
            this.$error(data.result.error || "unknown error");
            clearInterval(this.interval);
            clearInterval(this.interval);
          }
          if (
            data &&
            data.ready &&
            data.ready === true &&
            (data.result.error === "" || data.result.error == undefined)
          ) {
            clearInterval(this.interval);
            this.$store.dispatch("cart/getCarts");
          }
        });
    },
    defaultCartCheck() {
      if(!this.defaultCart) return;
      if(!this.defaultCart.id) return;
      if(!this.defaultCart.car || !this.defaultCart.car.vin){
        this.defaultCart.order_check_id = null;
      }
      if(!this.defaultCart.items.length || !(this.defaultCart.car) || !this.defaultCart.car.vin) return;
      this.$store
        .dispatch("cart/cartCheck", { id: this.defaultCart.id })
        .then((data) => {
          if (data.status === "success") {
            for (let i in this.carts) {
              if (parseInt(this.carts[i].id) === parseInt(this.defaultCartId)) {
                this.carts[i].order_check_id = data.task_id;
                this.carts[i].order_check_id = data.task_id;
                this.interval = setInterval(() => {
                  if (!this.carts[i]) return;
                  if (
                    this.carts[i].order_check_status === "ready" ||
                    !this.carts[i].order_check_id
                  ) {
                    clearInterval(this.interval);
                    return;
                  }
                  this.defaultCartCheckResult();
                }, 3000);
              }
            }
          }
        });
    },
    createCalculation(cart) {
      this.$store
        .dispatch("cart/transformCartToCalculation", cart)
        .then((data) => {
          this.$router.push({ name: "calculations", params: { id: data.id } });
        });
    },
    checkoutOrder(data) {
      this.newOrder.customer = data.customer;
      this.newOrder.customer_car_id = data.car ? data.car.id : null;
      this.newOrder.items = [];
      for (let i in data.items) {
        this.newOrder.items.push(data.items[i]);
        if (data.items[i].is_dummy) {
          this.$store.dispatch("common/showError", {
            error: this.$t(
              "componentMultiCart.there_are_items_without_price_in_the_cart"
            ),
          });
          return;
        }
      }
      if (this.newOrder.items.length > 0) {
        if (data.order_id) {
          //добавляем в существующий
          this.$store
            .dispatch("orders/orderAddFromCart", {
              cart_id: data.id,
              order_id: data.order_id,
              customer_car_id: data.customer_car_id
            })
            .then((id) => {
              if (id > 0) {
                this.$router.push({ name: "orders", params: { id } });
              }
            })
            .then(() => {
              this.$store.dispatch("cart/getCarts");
            });
        } else {
          //создаем новый заказ
          if (!this.newOrder.customer || !this.newOrder.customer.id) {
            this.$store.dispatch("common/showError", {
              error: this.$t("viewCustomers.customer_is_empty"),
            });
            return;
          }
          this.$store
            .dispatch("orders/orderStore", {
              cart_id: data.id,
              bid_id: data.bid_id,
            })
            .then((id) => {
              if (id > 0) {
                this.$router.push({ name: "orders", params: { id } });
              }
            })
            .then(() => {
              this.$store.dispatch("cart/getCarts");
            });
        }
      } else {
        this.$store.dispatch("common/showError", {
          error: this.$t("componentMultiCart.parts_list_is_empty"),
        });
      }
    },
    showGarageForSelectCar(item) {
      this.customerFormDialog.isVisible = true;
      this.customerFormDialog.customerId = item.customer.id;
      this.customerFormDialog.carId = item.car ? item.car.id : -1;

      this.tmpCarId = item.car ? item.car.id : -1;
      this.customerFormTabsId = 2;
    },
    toggleExpanded(item) {
      if (
        this.expanded.filter((i) => parseInt(i.id) === parseInt(item.id)).length
      ) {
        this.expanded = this.expanded.filter((i) => i.id !== item.id);
      } else {
        this.expanded.push(item);
      }
    },
    onResize() {
      this.$nextTick(() => {
        if (!document.getElementById("tableCart")) {
          this.tableHeight = "";
          return;
        }
        document.getElementById("tableCart").style.height = "auto";
        let element = document.getElementById("tableCart");
        let top = 0;
        do {
          top += element.offsetTop || 0;
          element = element.offsetParent;
        } while (element);
        this.tableHeight = window.innerHeight - top - 96 + "px";
      });
    },
    renameCart() {
      this.dialogRename = false;
      this.$store.dispatch("cart/renameDefaultCart", {
        name: this.newCartName,
      });
    },
  },
};
</script>
<style lang="css" scoped>
.table-card .v-tabs-bar {
  display: none !important;
}

.fixedHeight {
  height: 400px;
  margin-top: 20px !important;
}

.customerCreateForm {
  background: #fff;
  height: fit-content;
}
</style>
